import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { PARKING_ROLES, hasAnyRole } from './lib/roles';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { OfficerConsole } from './pages/console/OfficerConsole';
import { ContraventionDetail } from './pages/contraventions/ContraventionDetail';
import { ContraventionsList } from './pages/contraventions/ContraventionsList';
import { OfficersAdmin } from './pages/admin/OfficersAdmin';
import { ZonesAdmin } from './pages/admin/ZonesAdmin';
import { ChainVerify } from './pages/chain/ChainVerify';
import { Shell, type NavItem } from './ui/Shell';

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  const roles = persona.roles;
  // Matches m46-parking's officerRoles gate (requireRoles(ENFORCEMENT_OFFICER,
  // PARKING_SUPERVISOR, PARKING_ADMIN)) on POST /contraventions — the nav item
  // and the console route both defend-in-depth against the same three roles
  // the API itself checks, so no one sees an action that will just 403.
  const canIssue = hasAnyRole(roles, PARKING_ROLES.ENFORCEMENT_OFFICER, PARKING_ROLES.PARKING_SUPERVISOR, PARKING_ROLES.PARKING_ADMIN);
  const isAdmin = hasAnyRole(roles, PARKING_ROLES.PARKING_ADMIN);

  const items: NavItem[] = [];
  if (canIssue) items.push({ to: '/console', label: 'Officer Console', icon: 'Ⓟ' });
  items.push({ to: '/contraventions', label: 'Contraventions', icon: '☰' });
  if (isAdmin) items.push({ to: '/admin/zones', label: 'Zones & Tariffs', icon: '⌗' });
  if (isAdmin) items.push({ to: '/admin/officers', label: 'Officer Registry', icon: '☑' });
  items.push({ to: '/chain-verify', label: 'Chain Verify', icon: '✓' });

  const landing = canIssue ? '/console' : '/contraventions';

  return (
    <Routes>
      <Route element={<Shell title="Parking & Contravention" items={items} />}>
        <Route index element={<Navigate to={landing} replace />} />

        <Route path="console" element={canIssue ? <OfficerConsole /> : <Navigate to={landing} replace />} />

        <Route path="contraventions" element={<ContraventionsList />} />
        <Route path="contraventions/:id" element={<ContraventionDetail />} />

        <Route path="admin/zones" element={isAdmin ? <ZonesAdmin /> : <Navigate to={landing} replace />} />
        <Route path="admin/officers" element={isAdmin ? <OfficersAdmin /> : <Navigate to={landing} replace />} />

        <Route path="chain-verify" element={<ChainVerify />} />

        <Route path="*" element={<Navigate to={landing} replace />} />
      </Route>
    </Routes>
  );
}
